import { defineComponent, createElementBlock, openBlock, createElementVNode, Fragment, renderList, createVNode, withCtx, toDisplayString } from 'vue';
import _sfc_main$2 from './basler-components.es81.js';
/* empty css                       */
import _sfc_main$1 from './basler-components.es133.js';

const _hoisted_1 = { class: "nav-top" };
const _hoisted_2 = { class: "nav-top__list" };
const _hoisted_3 = { class: "nav-top__item-text" };
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "ServiceNavigation",
  props: {
    items: {}
  },
  emits: ["navigate"],
  setup(__props, { emit: __emit }) {
    const emit = __emit;
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("nav", _hoisted_1, [
        createElementVNode("ul", _hoisted_2, [
          (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.items, (item, index) => {
            return openBlock(), createElementBlock("li", {
              class: "nav-top__item",
              key: index
            }, [
              createVNode(_sfc_main$1, {
                uri: item.link.uri,
                target: item.link.target,
                rel: item.link.rel,
                class: "nav-top__item-link nav-top__item-link--icon-left",
                onClick: _cache[0] || (_cache[0] = ($event) => emit("navigate"))
              }, {
                default: withCtx(() => [
                  createVNode(_sfc_main$2, {
                    name: item.iconName,
                    class: "nav-top__item-icon"
                  }, null, 8, ["name"]),
                  createElementVNode("span", _hoisted_3, toDisplayString(item.label), 1)
                ]),
                _: 2
              }, 1032, ["uri", "target", "rel"])
            ]);
          }), 128))
        ])
      ]);
    };
  }
});

export { _sfc_main as default };
